<template>
  <div id="app">
    <app-header></app-header>
    <router-view class="main container"></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from "./components/navigation/Header.vue";
import Footer from "./components/navigation/Footer.vue";
export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
};
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main {
  flex-grow: 1;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
